import { Injectable } from "@angular/core";
import { ResourceService } from "./resource.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { AttributeModel } from "../main/dynamic/model/attribute.model";

@Injectable({
    providedIn: 'root'
})
export class EmailService extends ResourceService<AttributeModel> {

    constructor(
        http: HttpClient, 
        settings: GlobalSettings, 
        authService: AuthenticationService) {
            super(http, "motor/Email/Comment", settings.motorUrl, authService)
    }

    send(attribute: AttributeModel): Observable<AttributeModel> {
        return this.create(attribute)
    }
}